<template>
  <div>
    <h2>Servers</h2>
    <reporting-api pageName="server_list">
      <template slot-scope="data">
        <b-tabs>
          <b-tab
              v-for="(groupName, i) in Object.keys(serverGroups(data.page.all_servers))" :key="groupName"
              title-link-class="text-dark"
              :title="groupName" :active="i == 0">
            <table class="table table-striped">
              <tr v-for="server in serverGroups(data.page.all_servers)[groupName]" :key="server.location">
                <td>
                  <router-link :to="{ name: 'server-details', params: { server: server.location } }">
                    {{ server.store || server.location }}
                  </router-link>
                </td>
              </tr>
            </table>
          </b-tab>

          <b-tab v-if="data.page.inactive_servers" title-link-class="text-success" title="Inactive Servers">
            <table class="table table-striped">
              <tr v-for="server in data.page.inactive_servers" :key="server.location">
                <td>
                  <router-link :to="{ name: 'server-details', params: { server: server.location } }">
                    {{ server.region || 'Unclassified Region' }},
                    {{ server.store || server.location }}
                  </router-link>
                </td>
              </tr>
            </table>
          </b-tab>
        </b-tabs>
      </template>
    </reporting-api>
  </div>
</template>

<script>
import ReportingApi from '../components/ReportingApi.vue';

export default {
  components: { ReportingApi },
  methods: {
    serverGroups(allServers) {
      let results = {};
      allServers.forEach(s => {
        if (!results[s.region]) {
          results[s.region] = [];
        }
        results[s.region].push(s);
      });
      return results;
    }
  }
};
</script>

